export default __webpack_public_path__ + "google_button.97be55.png";